module.exports = __webpack_public_path__ + "img/icon_map_2_on_101.3734501c.png";